import React from 'react';

interface DesignerCardContext {
    highlightNewDesigners?: boolean;
    displayStatsTable?: boolean;
}

export default React.createContext<DesignerCardContext>({
    highlightNewDesigners: true,
    displayStatsTable: true,
});
